import {actionTypes} from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_USER_INFO_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.UPDATE_USER_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.UPDATE_USER_INFO_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.UPDATE_USER_INFO_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        default:
            return state;
    }
};
